import React, { useEffect } from 'react';
import { map } from 'lodash';
import { Row1, Row2, Row3 } from './ReservationRows';
import { orderBy } from 'lodash';
import moment from 'moment';

function ReservationsList({ reservationData }) {
  const sortedReservations = orderBy(
    reservationData,
    (reservation) => {
      return moment(reservation.reservationDate, 'DD.MM.YYYY').format(
        'YYYYMMDD'
      );
    },
    ['asc']
  );

  return (
    <>
      {map(
        sortedReservations,
        ({
          lotName,
          reservationDate,
          reservationId,
          place,
          timeFrom,
          timeTo,
          latitude,
          longitude,
          floor
        }) => {
          const reservationTitle = `Rezervace místa ${place}`;
          return (
            <div key={reservationId}>
              <h2 className="reservation-title">{reservationTitle}</h2>
              <div key={reservationId} className="card">
                <Row1
                  lotName={lotName}
                  reservationDate={reservationDate}
                  reservationId={reservationId}
                />
                <div className="card__body">
                  <Row2 timeFrom={timeFrom} timeTo={timeTo} />
                  <Row3
                    latitude={latitude}
                    longitude={longitude}
                    floor={floor}
                  />
                </div>
              </div>
            </div>
          );
        }
      )}
    </>
  );
}

export default ReservationsList;
